<div>
  <div class="no-connection"></div>
  <div class="text-center mt-4 mr-5 ml-5 mb-4">
    <h2 class="text-uppercase font-weight-bold">Slow or no internet connection!</h2>
    <h6 class="text-capitalize">check your internet settings and try again</h6>
  </div>
</div>